"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var flux_1 = require("flux");
exports.default = new flux_1.Dispatcher();
